export default __webpack_public_path__ + "static/media/ricevuta_acquisto_smartphonecash_-07.9efe5a06.svg";